import { render, staticRenderFns } from "./openUser.vue?vue&type=template&id=237f9d4b&"
import script from "./openUser.vue?vue&type=script&lang=js&"
export * from "./openUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports